import { writable } from 'svelte/store';
import ajax from '../ajax/ajax';
import jwtDecode from "jwt-decode";
import getToken, { setToken } from './token';
const initialUser = { id: undefined, name: undefined, loggedIn: false, loggingIn: false, error: undefined };
function createUserStore() {
    let user = Object.assign({}, initialUser);
    const storedToken = getToken();
    if (storedToken) {
        user = loginViaToken(storedToken);
    }
    function loginViaToken(token) {
        const decoded = jwtDecode(token);
        if (Date.now() >= decoded.exp * 1000) {
            return Object.assign(Object.assign({}, initialUser), { error: 'Token expired.' });
        }
        setToken(token);
        return { id: decoded.userId, name: decoded.username, loggedIn: true, loggingIn: false, error: undefined };
    }
    const { subscribe, set } = writable(user);
    return {
        subscribe,
        logout: () => {
            setToken(null);
            set(Object.assign({}, initialUser));
        },
        login: (email, password, group) => {
            set(Object.assign(Object.assign({}, initialUser), { loggingIn: true }));
            ajax.post(`/${group}/auth/login`, {
                email,
                password,
            }, (response) => {
                set(loginViaToken(response.token));
            }, (error, status) => {
                if (status === 401) {
                    set(Object.assign(Object.assign({}, initialUser), { error: 'Wrong username or password.' }));
                }
                else if (status === 400) {
                    set(Object.assign(Object.assign({}, initialUser), { error: 'Please provide email and password.' }));
                }
                else {
                    set(Object.assign(Object.assign({}, initialUser), { error: 'Could not connect to server.' }));
                }
            });
        }
    };
}
export const userStore = createUserStore();
